import Logger from '../lib/logger';

class ThemeMosaic extends HTMLElement {

  constructor() {
    super();
		this.NAME = `ThemeMosaic`;
		this.abortController;
    this.container = this.querySelector('[data-mosaic-container]');
    this.lightbox = this.querySelector('[data-mosaic-lightbox]');
    this.closeBtn = this.querySelector('[data-mosaic-lightbox-close-btn]');
    this.areas = this.querySelectorAll('[data-area-clickable]');
    this.directionalBtns = this.querySelectorAll('[data-carousel-btn][data-dir]');
    this.carousel = this.querySelector('simple-carousel');
    this.max = this.areas.length;
    this.breakpoint = 960;
    //
		Logger.info(`${this.NAME} > constructor`);
  }

  connectedCallback() {
		Logger.info(`${this.NAME} > connectedCallback`);
    this.init();
  }

  disconnectedCallback() {
		Logger.info(`${this.NAME} > disconnectedCallback`);
    this.abortController.abort();
    this.abortController = null;
  }

  static get observedAttributes() {
    return ['carousel-breakpoint'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
		Logger.info(`${this.NAME} > attributeChangedCallback, ${name} ${newValue}`);
    //
    if (name === 'carousel-breakpoint') {
      const bp = parseInt(newValue);
      if (!isNaN(bp)) this.breakpoint = bp;
		}
  }

  init() {
    this.abortController = new AbortController();
    const { signal } = this.abortController.signal;
    //
    this.areas.forEach((area) => {
      area.addEventListener('click', () => {
        this.curIndex = parseInt(area.dataset.area);
        this.lightbox.dataset.activeItem = area.dataset.area;
        this.lightbox.dataset.show = 'true';
      }, { signal })
    });
    //
    this.addEventListener('click', (e) => {
      if (e.target === this.container || e.target === this.lightbox) {
        this.lightbox.dataset.show = 'false';
      }
    }, { signal });
    //
    this.closeBtn.addEventListener('click', () => {
      this.lightbox.dataset.show = 'false';
    }, { signal });
    //
    this.directionalBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        this.onDirBtn(e.target.dataset.dir)
      }, { signal });
    });
    //
    window.addEventListener('resize', () => this.onResize(), { signal });
    this.onResize();
  }

  onDirBtn(dir) {
    let index = dir === 'right' ? this.curIndex + 1 : this.curIndex - 1;
    index = index > this.max ? 1 : (index < 1 ? this.max : index);
    this.curIndex = index;
    this.lightbox.dataset.activeItem = this.curIndex;
  }

  onResize() {
    if (window.innerWidth > this.breakpoint && this.carousel.parentNode) {
      this.carousel.remove();
    } else if (window.innerWidth <= this.breakpoint && !this.carousel.parentNode) {
      this.container.appendChild(this.carousel);
    }
  }

}

customElements.define('theme-mosaic', ThemeMosaic);